import { render, staticRenderFns } from "./QuizLayoutA.vue?vue&type=template&id=0c8cb52e&"
import script from "./QuizLayoutA.vue?vue&type=script&lang=js&"
export * from "./QuizLayoutA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports